import { HTMLAttributeAnchorTarget } from 'react';

export type VisibleSubLinks = { menuItemId: string; subLinksAggregatorId: string } | null;

export interface MenuItem {
    id: string;
    label: string;
    unCollapses?: Array<MenuLink | MenuWithSubLinks>;
    linkTo?: string;
    // used on links that point outside of the marketplace (example: '_blank')
    target?: HTMLAttributeAnchorTarget;
}

export interface MenuWithSubLinks {
    label: string;
    subLinks: MenuLink[];
    url?: never;
}

interface MenuLink {
    label: string;
    url: string;
    subLinks?: never;
}

export enum MenuPages {
    Products = 'products',
    Services = 'services',
    Campaigns = 'campaigns',
    PromoBaskets = 'promo-baskets',
    Merchants = 'merchants',
    Portal = 'portal',
    Contacts = 'contacts',
}
